import { LifesHubColors } from 'src/utils/views'

export const colors = {
    selected: LifesHubColors.warning
}

export const formatNumberToCompactShortForm = (function buildFormatNumber() {
    const numformatter = Intl.NumberFormat('pt-BR', {
        notation: 'compact',
        compactDisplay: 'short'
    })

    return (n: number) => {
        if (n === undefined || Number.isNaN(n)) {
            return ''
        }
        return numformatter.format(n)
    }
})()

export const formatNumberToCompactLongForm = (function buildFormatNumber() {
    const numformatter = Intl.NumberFormat('pt-BR', {
        notation: 'compact',
        compactDisplay: 'long'
    })

    return (n: number) => {
        if (n === undefined || Number.isNaN(n)) {
            return ''
        }
        return numformatter.format(n)
    }
})()

export const formatNumber = (function buildFormatNumber() {
    const numformatter = Intl.NumberFormat('pt-BR')

    return (n: number) => {
        if (n === undefined || Number.isNaN(n)) {
            return ''
        }
        return numformatter.format(n)
    }
})()

export function pluralize(count: number, singular: string, plural: string) {
    return `${formatNumber(count)} ${count === 1 ? singular : plural}`
}
